import { useLanguage } from "../i18n/Language";
import React from 'react';
import { useAppointmentWhatsApp } from './QuickContact';

const BookAppointment = () => {
  const { t } = useLanguage();
  const appointmentWhatsApp = useAppointmentWhatsApp();
  return (
    <section id="contact" className="py-16 md:py-20 px-6 md:px-8 bg-white">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl text-secondary mb-4 font-bold">{t("Book an Appointment")}

        </h2>
        <p className="text-lg md:text-xl text-text-color mb-12 opacity-80">{t("Schedule your consultation with Dr. Bharat Reddy Katta")}

        </p>
        <div className="flex justify-center items-stretch gap-6 md:gap-8 flex-wrap">
          <div
            className="flex flex-col items-center justify-center gap-4 p-8 md:p-10 bg-gradient-to-br from-primary to-secondary text-white rounded-2xl border-2 border-transparent shadow-md min-w-[250px] flex-1 max-w-[300px] hover:-translate-y-1 hover:shadow-xl transition-all duration-300">

            <i className="fas fa-phone text-4xl text-white"></i>
            <div className="flex flex-col items-center gap-1">
              <a href="tel:+917893107890" className="text-base text-white/90 font-medium no-underline hover:text-white hover:underline" aria-label={t("Call +91 78931 07890")}>+91 78931 07890</a>
            </div>
          </div>
          <a
            href={appointmentWhatsApp}
            target="_blank"
            rel="noopener noreferrer"
            className="flex flex-col items-center justify-center gap-4 p-8 md:p-10 bg-gradient-to-br from-green-500 to-green-600 text-white rounded-2xl no-underline transition-all duration-300 border-2 border-transparent shadow-md min-w-[250px] flex-1 max-w-[300px] hover:-translate-y-1 hover:shadow-xl hover:border-green-400">

            <i className="fab fa-whatsapp text-4xl text-white"></i>
            <small className="text-base text-white/90 font-medium">{t("WhatsApp Chat")}</small>
          </a>
        </div>
      </div>
    </section>);

};

export default BookAppointment;
